import gql from 'graphql-tag'
import { type Warehouse } from 'legacy/common/types'
import { useRetailersQuery } from 'legacy/apollo/clientHooks'
import { toInteger } from 'utils/parsing/numbers'

export const FETCH_WAREHOUSES_QUERY = gql`
  query ($id: ID!) {
    partner(id: $id) {
      warehouses {
        id
        name
        logo {
          url
        }
      }
    }
  }
`

export interface WarehousesData {
  partner: {
    warehouses: (Omit<Warehouse, 'id'> & { id: string })[]
  }
}

export interface WarehousesVariables {
  id?: number
}

export const useFetchWarehouses = (variables: WarehousesVariables) => {
  const { data, error, loading } = useRetailersQuery<WarehousesData, WarehousesVariables>(
    FETCH_WAREHOUSES_QUERY,
    {
      variables,
      // If we don't have an ID passed in yet, we just skip the request
      skip: !variables.id,
    }
  )

  // Convert the id strings into integers
  const warehouses =
    data &&
    data.partner.warehouses.map(({ id, ...rest }) => ({
      id: toInteger(id),
      ...rest,
    }))

  return {
    warehouses,
    error,
    loading,
  }
}
